import React, { useState, useEffect } from 'react';
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import DataTable from 'react-data-table-component';
import { collection, doc, updateDoc, deleteDoc, addDoc, getDocs, query, orderBy } from 'firebase/firestore';
import { auth, db } from "../../firebase";
import { CountriesDB } from '../db/CountriesDB';

import './Coaches.css'

function Coaches() {

  const [coaches, setCoaches] = useState([])
  const [idCoach, setIdCoach] = useState('')
  const [teams, setTeams] = useState([])
  const [countries, setCountries] = useState([])

  const [name, setName] = useState('')
  const [team, setTeam] = useState('') 
  const [birthDate, setBirthDate] = useState('')
  const [nationality, setNationality] = useState('')
  const [lastTeam, setLastTeam] = useState('')
  const [categoryLastTeam, setCategoryLastTeam] = useState('')
  const [countryLastTeam, setCountryLastTeam] = useState('')
  const [urlPhoto, setUrlPhoto] = useState('')

  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  const PAGE_SIZE = 10;

  useEffect(() => {
    const getCoachesFromFirestore = async () => {
      try {
        const coachesCollectionRef = collection(db, 'coaches');
        const coachesQuery = query(coachesCollectionRef, orderBy('name'));
        const snapshot = await getDocs(coachesQuery);
        const coachesData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCoaches(coachesData);
      } catch (error) {
        console.error('Error al obtener los datos de los entrenadores:', error);
      }
    };

    const getTeamsFromFirestore = async () => {
      try {
        const teamsCollectionRef = collection(db, 'teams');
        const teamsQuery = query(teamsCollectionRef, orderBy('name'));
        const snapshot = await getDocs(teamsQuery);
        const teamsData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setTeams(teamsData);
      } catch (error) {
        console.error('Error al obtener los datos de los equipos:', error);
      }
    };

    if (!user) return navigate("/")

    getCoachesFromFirestore();
    getTeamsFromFirestore();
    CountriesDB.getAll().then(countriesData => {
      setCountries(countriesData)
    })
  }, [user,navigate]);

  const columns = [
    {
      name: 'Nombre',
      selector: row => row['name'],
      sortable: true,
    },
    {
      name: 'Equipo',
      selector: row => getNameTeam(row['team']),
      sortable: true,
    },
    {
      cell:(row) => <svg onClick={(e) => handleEditar(e, row)} id={row.ID} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="iconAction"><path d="M1.172,19.119A4,4,0,0,0,0,21.947V24H2.053a4,4,0,0,0,2.828-1.172L18.224,9.485,14.515,5.776Z"/><path d="M23.145.855a2.622,2.622,0,0,0-3.71,0L15.929,4.362l3.709,3.709,3.507-3.506A2.622,2.622,0,0,0,23.145.855Z"/></svg>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      cell:(row) => <svg onClick={(e) => handleEliminar(e, row.id)} id={row.ID} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="iconAction"><path d="m17,4v-2c0-1.103-.897-2-2-2h-6c-1.103,0-2,.897-2,2v2H1v2h1.644l1.703,15.331c.169,1.521,1.451,2.669,2.982,2.669h9.304c1.531,0,2.813-1.147,2.981-2.669l1.703-15.331h1.682v-2h-6Zm-8-2h6v2h-6v-2Zm6.957,14.543l-1.414,1.414-2.543-2.543-2.543,2.543-1.414-1.414,2.543-2.543-2.543-2.543,1.414-1.414,2.543,2.543,2.543-2.543,1.414,1.414-2.543,2.543,2.543,2.543Z"/></svg>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];

  const handleGuardar = async () => {
    const nuevoEntrenador = {
      name: name,
      team: team,
      birthDate: birthDate,
      nationality: nationality,
      lastTeam: lastTeam,
      categoryLastTeam: categoryLastTeam,
      countryLastTeam: countryLastTeam,
      urlPhoto: urlPhoto
    };
    if (idCoach === '') {
      try {
        const docRef = await addDoc(collection(db, 'coaches'), nuevoEntrenador)
        setCoaches([...coaches, { id: docRef.id, ...nuevoEntrenador }])
        handleLimpiar()
      } catch (error) {
        console.error('Error al agregar el entrenador:', error)
      }
    } else {
      try {
        const coachRef = doc(db, 'coaches', idCoach)
        await updateDoc(coachRef, nuevoEntrenador)
        const nuevosEntrenadores = [...coaches]
        const index = nuevosEntrenadores.map(e => e.id).indexOf(idCoach)
        nuevoEntrenador.id=idCoach
        nuevosEntrenadores[index] = nuevoEntrenador
        setCoaches(nuevosEntrenadores)
        handleLimpiar()
      } catch (error) {
        console.error('Error al modificar el entrenador:', error);
      }
    }
  };

  const handleEditar = (event, row) => {
    setName(row.name)
    setTeam(row.team)
    setBirthDate(row.birthDate)
    setNationality(row.nationality)
    setLastTeam(row.lastTeam)
    setCategoryLastTeam(row.categoryLastTeam)
    setCountryLastTeam(row.countryLastTeam)
    setUrlPhoto(row.urlPhoto)
    setIdCoach(row.id)
  };

  const handleEliminar = async (event, id) => {
    if (window.confirm("Está seguro que desea eliminar el entrenador?")) {
      const coachRef = doc(db, 'coaches', id)
      await deleteDoc(coachRef)
      const nuevosEntrenadores = coaches.filter(coach => coach.id !== id)
      setCoaches(nuevosEntrenadores)
    }
  };

  const handleLimpiar = () => {
    setName('')
    setTeam('')
    setBirthDate('')
    setNationality('')
    setLastTeam('')
    setCategoryLastTeam('')
    setCountryLastTeam('')
    setUrlPhoto('')
    setIdCoach('')
  }

  const getNameTeam = id => {
    const teamsFiltered = teams.filter(team => id === team.id)
    if (teamsFiltered.length === 1) {
      return teamsFiltered[0].name
    } 
    return ""
  }


  const showTeams = () => {
    return teams.map(team => <option value={team.id}>{team.name}</option>)
  }

  const showCountries = () => {
    return countries.map(country => <option value={country.name}>{country.name}</option>)
  }

  return (
    <div className="container-coaches">
      <h2>Entrenadores</h2>
      <h3>Agregar Entrenador</h3>
      <div id="data-coach">
        <select 
        value={team}
        onChange={(e) => setTeam(e.target.value)}>
          <option value=""></option>
          {showTeams()}
        </select>
        <input
          type="text"
          placeholder="Nombre"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Fecha nacimiento"
          value={birthDate}
          onChange={(e) => setBirthDate(e.target.value)}
        />
        <select 
        value={nationality}
        onChange={(e) => setNationality(e.target.value)}>
          <option value=""></option>
          {showCountries()}
        </select>
        <input
          type="text"
          placeholder="URL Foto"
          value={urlPhoto}
          onChange={(e) => setUrlPhoto(e.target.value)}
        />
      </div>
      <div id="data-last-season">
        <label>Temporada 25/26</label>
        <input
          type="text"
          placeholder="Equipo"
          value={lastTeam}
          onChange={(e) => setLastTeam(e.target.value)}
        />
        <input
          type="text"
          placeholder="Categoría"
          value={categoryLastTeam}
          onChange={(e) => setCategoryLastTeam(e.target.value)}
        />
        <select 
        value={countryLastTeam}
        onChange={(e) => setCountryLastTeam(e.target.value)}>
          <option value=""></option>
          {showCountries()}
        </select>
      </div>
      <button onClick={handleGuardar}>Guardar</button>
      <button onClick={handleLimpiar}>Limpiar</button>
      <div className="table">
        <DataTable
          columns={columns}
          data={coaches}
          pagination
          paginationTotalRows={coaches.length}
          paginationPerPage={PAGE_SIZE}
          paginationRowsPerPageOptions={[PAGE_SIZE]}
      />
      </div>
    </div>
  )
}

export default Coaches